<!--
 * @Author: your name
 * @Date: 2021-07-09 14:08:18
 * @LastEditTime: 2022-04-22 16:58:15
 * @LastEditors: Please set LastEditors
 * @Description: layout
 * @FilePath: \smart-community\src\layout\index.vue
-->
<template>
  <div class="layoutPage">
    <layout-page :data="menuList"></layout-page>
    <layout-main></layout-main>
  </div>
</template>
<script>
import LayoutPage from "./module/LayoutHander.vue";
import LayoutMain from "./module/LayoutMain.vue";
import { defineComponent, reactive, toRefs, provide, readonly } from "vue";
import { createContext } from "../hooks/core/useContext";
import { useRoute, onBeforeRouteUpdate } from "vue-router";
import util from "@util/js";
import { getRouter } from "@/api/common.js";
export default defineComponent({
  name: "",
  components: { LayoutPage, LayoutMain },
  props: {},
  setup(props) {
    const state = reactive({
      system: {},
      paths: [],
      menuList: [],
    });
    const refData = toRefs(state);
    provide("systemss", refData.system);
    const route = useRoute();
    const handleSelect = (key) => {
      const options = {
        keys: "url",
        childs: "list",
        spare: "menuId",
      };
      state.paths = util.flattenDeepParentsId(state.menuList, key, options);
    };
    onBeforeRouteUpdate(async (to, from) => {
      handleSelect(to.name);
    });
    // 加载路由
    const getMenu = async () => {
      const res = await getRouter();
      const menus = [];
      // 判断是内网还是外网给他添加不同的默认近的首页
      if (window.lgoinList) {
        menus.push({
          icon: "admin",
          menuId: 9999,
          name: "首页",
          open: null,
          orderNum: 0,
          parentId: 0,
          parentName: null,
          perms: "",
          type: "1",
          typeDict: "菜单",
          url: "Home",
        });
      } else {
        menus.push({
          icon: "admin",
          menuId: 9999,
          name: "首页",
          open: null,
          orderNum: 0,
          parentId: 0,
          parentName: null,
          perms: "",
          type: "1",
          typeDict: "菜单",
          url: "communityKanbans",
        });
      }

      res.menuList = res.menuList.filter((item) => {
        if (item.menuId !== 1) {
          return item;
        } else {
          state.system = item;
        }
      });
      state.menuList = [...menus, ...res.menuList] || menus;
      handleSelect(route.name);
    };
    getMenu();
    createContext("layoutData", state);
    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
.layoutPage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--el-bg-color);
}
</style>
